import { useQuery } from '@tanstack/react-query';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { SYNC_STATUSES } from '../httpClients/RepositoryClient/consts';
import { QUERY_KEYS } from './consts';

const POLL_INTERVAL_MS = 1500;

/**
 * Polls the Gerrit auto-import status while it runs, stopping once the server
 * reports a terminal `SyncStatus` (`success` or `failed`).
 */
export const useGerritImportStatusQuery = (
  installationId: string | undefined,
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: [QUERY_KEYS.GERRIT_IMPORT_STATUS, installationId],
    queryFn: () => {
      if (!installationId) {
        throw new Error('Installation id is required');
      }

      return RepositoryClient.gerritGetImportStatus(installationId);
    },
    enabled: !!installationId && (options?.enabled ?? true),
    refetchInterval: (query) => {
      const status = query.state.data?.status;

      return status === SYNC_STATUSES.SUCCESS || status === SYNC_STATUSES.FAILED
        ? false
        : POLL_INTERVAL_MS;
    },
  });
